import {
    usePaginatedResource,
    useResourceItem,
    useCreateResource,
    useEditResource,
    useDeleteResource,
} from "./useCrudResource"
import {
    getVehicleFuelStocks,
    getVehicleFuelStock,
    createVehicleFuelStock,
    editVehicleFuelStock,
    deleteVehicleFuelStock,
    getAllVehicleFuelStocks,
    getTrashedVehicleFuelStocks,
    restoreVehicleFuelStock,
} from "api/vehicleFuelStocks"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const VEHICLE_FUEL_STOCK_QUERY_KEY = "vehicle-fuel-stocks"
export const VEHICLE_FUEL_STOCK_GROUP_QUERY_KEY = "vehicle-fuel-stocks-group"

// -------------------- FETCH PAGINATED --------------------
export const useVehicleFuelStocks = (params = {}, enabled = true) => {
  return usePaginatedResource(
    VEHICLE_FUEL_STOCK_QUERY_KEY,
    getVehicleFuelStocks,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useVehicleFuelStock = (id, enabled = true) => {
  return useResourceItem(VEHICLE_FUEL_STOCK_QUERY_KEY, getVehicleFuelStock, id)
}

// -------------------- CREATE --------------------
export const useCreateVehicleFuelStock = () => {
  return useCreateResource(createVehicleFuelStock, VEHICLE_FUEL_STOCK_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditVehicleFuelStock = () => {
  return useEditResource(editVehicleFuelStock, VEHICLE_FUEL_STOCK_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeleteVehicleFuelStock = () => {
  return useDeleteResource(deleteVehicleFuelStock, VEHICLE_FUEL_STOCK_QUERY_KEY)
}

// -------------------- ADDITIONAL --------------------

// Get all vehicle fuel stocks without pagination
export const useAllVehicleFuelStocks = (params = {}) => {
  return usePaginatedResource(
    VEHICLE_FUEL_STOCK_QUERY_KEY,
    getAllVehicleFuelStocks,
    { ...params, all: true },
    true
  )
}

// Get trashed vehicle fuel stocks
export const useTrashedVehicleFuelStocks = (params = {}) => {
  return usePaginatedResource(
    VEHICLE_FUEL_STOCK_QUERY_KEY,
    getTrashedVehicleFuelStocks,
    params,
    true
  )
}

// Restore a trashed vehicle fuel stock
export const useRestoreVehicleFuelStock = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreVehicleFuelStock,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      // Update paginated cache
      queryClient.setQueriesData([VEHICLE_FUEL_STOCK_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      // Update individual item cache
      queryClient.setQueryData(
        [VEHICLE_FUEL_STOCK_QUERY_KEY, id],
        restoredItem
      )
    },
  })
}
